import React, { Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';

import { SelectSitesTableReduxForm } from 'Common/SelectSitesTableReduxForm';
import { ASSIGN_TAX_SITES_FORM_NAME } from 'Common/FormEnum';
import { AssignTaxRateSitesFieldEnum as Fields } from 'Common/FieldEnum';

const assignSites = (props) => {
  return (
    <Fragment>
      <Form>
        <Grid>
          <Grid.Column>
            <Grid.Row>
              <Field
                name={Fields.Sites}
                component={SelectSitesTableReduxForm}
                loading={props.loading}
                enableReinitialize={true}
              />
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Form>
    </Fragment>
  );
};

const validate = (values) => {
  const errors = {};
  if (
    !Array.isArray(values[Fields.Sites]) ||
    values[Fields.Sites].length === 0
  ) {
    errors[Fields.Sites] = 'At least 1 site must be selected';
  }

  return errors;
};

export const AssignSitesForm = reduxForm({
  form: ASSIGN_TAX_SITES_FORM_NAME,
  validate,
  enableReinitialize: true,
})(assignSites);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/taxRates/AssignSitesForm.js